export default __webpack_public_path__ + "static/media/fitness.14e3759a.mp4";